export default __webpack_public_path__ + "static/media/autoportrait2.ef47b10f.jpg";